import BpkButton, {
  BUTTON_TYPES,
  SIZE_TYPES,
} from '@skyscanner-internal/backpack-web/bpk-component-button';
import BpkSectionHeader from '@skyscanner-internal/backpack-web/bpk-component-section-header';
import {
  BpkTable,
  BpkTableBody,
} from '@skyscanner-internal/backpack-web/bpk-component-table';

import withErrorBoundary from '../ErrorBoundary';
import Icon, { ICON_SIZE } from '../common/Icon';
import { useMBDContext } from '../common/MBD/useMBDContext';

import type { DrivingInCityInfoProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/DrivingInCityProps';

import STYLES from './DrivingInCity.module.scss';

const DrivingInCityInfo = ({
  ctaText,
  dayViewUrl,
  header,
  sections,
}: DrivingInCityInfoProps) => {
  const IconComponent = Icon('chevron-right', ICON_SIZE.SMALL);
  const { buildMBDParam, rawComponentName } = useMBDContext();
  const buttonMbdComponentName = `${rawComponentName}_cta`;
  if (!sections?.length) return null;

  return (
    <div
      className={STYLES.DrivingInCityInfo}
      data-testid="driving-in-city-component"
      data-tracking-element-id={rawComponentName}
      data-tracking-common-params={buildMBDParam(rawComponentName)}
    >
      <BpkSectionHeader title={header} />
      <BpkTable className={STYLES.Sections}>
        <BpkTableBody className={STYLES.Sections__wrap}>
          {sections.map((section, index) => (
            <tr className={STYLES.SectionRow} key={section.sectionTitle}>
              <td className={STYLES.SectionCell}>
                <div className={STYLES.SectionTitle}>
                  {section.sectionTitle}
                </div>
                <div className={STYLES.SectionSummary}>
                  {section.boldSummaryLine}
                </div>
                <div className={STYLES.SectionParagraph}>
                  {section.paragraph}
                </div>
              </td>
            </tr>
          ))}
        </BpkTableBody>
      </BpkTable>
      {ctaText && dayViewUrl && (
        <BpkButton
          className={STYLES.ctaButton}
          href={dayViewUrl}
          type={BUTTON_TYPES.primary}
          size={SIZE_TYPES.small}
          data-tracking-element-id={buttonMbdComponentName}
          data-tracking-common-params={buildMBDParam(buttonMbdComponentName)}
        >
          {ctaText}
          <IconComponent className={STYLES.icon} />
        </BpkButton>
      )}
    </div>
  );
};

const DrivingInfoWithErrorBoundary = withErrorBoundary(
  DrivingInCityInfo,
  'driving-in-city-component',
);

export default DrivingInfoWithErrorBoundary;
